// src/store/categoriesStore.ts
import { create } from "zustand";

type CategoryLite = {
  id: string;
  name: string;
};

interface State {
  // Si es null => estamos en "Home"
  categorySelected: CategoryLite | null;
  setCategorySelected: (category: CategoryLite | null) => void;
  isManualScrolling: boolean;
  setIsManualScrolling: (v: boolean) => void;
}

export const useCategoriesStore = create<State>((set) => ({
  categorySelected: null, // Home por defecto
  setCategorySelected: (categorySelected) => set({ categorySelected }),
  isManualScrolling: false,
  setIsManualScrolling: (v) => set({ isManualScrolling: v }),
}));